import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from "./store";
import tool from "@/libs/tools"

import "./assets/style/init.scss"
import "./assets/style/color.scss";
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'
import ZhST from './language/zh'
import * as Msg  from '@/api/notify'


Vue.prototype.$ZhST = new ZhST();
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$Msg = Msg;
Vue.prototype.$tool = tool;
// 正式
// Vue.prototype.$FrontUrl = 'https://xtbg.gdzwfw.gov.cn/gdxzzfpc/laws/zf-law-plat';
// 测试、开发
// Vue.prototype.$FrontUrl = 'http://192.168.0.206:9014';
// Vue.prototype.$FrontUrl = 'http://192.168.4.145:8083';
// 正式
// Vue.prototype.$FrontUserUrl = 'https://xtbg.gdzwfw.gov.cn/gdxzzfpc/laws/zf-law-plat/#/';
// 测试、开发
// Vue.prototype.$FrontUserUrl = 'http://192.168.0.206:9014/#/';
// Vue.prototype.$FrontUserUrl = 'http://192.168.4.145:8083/#/';

new Vue({
    router,
    store,
    render: h => h(App),
    mounted() {
        this.$ZhST.init();
    },
}).$mount('#app')
router.beforeEach( (to, from, next) => { //这里用到导航守卫
// store.commit("setCurrRouteNme", {currRouteNme:to.name});
// store.dispatch("setMenuList").then( ()=> { //因为面包屑的数据来自左侧菜单,这边先获取左侧导航数据然后根据当前路径生成面包屑
//     store.dispatch("setBreadCrumb");
// });

next();
})
